export default __webpack_public_path__ + "img/title-404-mobile.png?ad3b";